import { useState } from 'react';

export function useDialogStatus(isTotalProgramScenario: boolean) {
  const [showDialog, setShowDialog] = useState(false);
  const [valueType, setValueType] = useState('');
  const [dialogValue, setDialogValue] = useState<number | string>(0);

  const openDialog = (selectedValueType: string, value: number | string) => {
    if (isTotalProgramScenario) {
      setValueType(selectedValueType);
      setShowDialog(true);
      setDialogValue(value);
    }
  };

  return { showDialog, setShowDialog, valueType, dialogValue, openDialog };
}
